import React from 'react';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import RestaurantIcon from '@material-ui/icons/Restaurant';

export default function LunchActivity({ assignment, containerClass, handleAssignmentFunc }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      key={`lunch_${assignment.index}`}
      className={containerClass}
      data-start-datetime={assignment.totalTime.visual.startDate}
      data-duration={assignment.totalTime.visual.duration}
      onClick={() => handleAssignmentFunc(assignment)}
    >
      <Box>
        <RestaurantIcon />
        <Typography className="ellipsis" variant="subtitle2" display="block">
          {assignment.totalTime.actual.duration} min
        </Typography>
      </Box>
    </Box>
  );
}
